import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { NotFoundPageComponent } from "./not-found-page.component";

@NgModule({
  declarations: [NotFoundPageComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, RouterModule],
})
export class NotFoundPageModule {}
